export const GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_ABORTED =
  'GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_ABORTED';
export const GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_REQUESTED =
  'GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_REQUESTED';
export const GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_COMPLETED =
  'GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_COMPLETED';
export const GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_FAILED =
  'GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_FAILED';
